import { useState, useEffect, useReducer } from "react";
import { Button, Card, Col, Row } from "reactstrap";
import DataGrid from "../../components/dataGrid/DataGrid";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QueryString from "qs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import moment from "moment";
// import { Edit } from "react-feather";

import { getDispatches, DispatchData } from "../../services/dispatch.service";

import { Printer } from "react-feather";
// import toast from "react-hot-toast";
import FormInput from "../../components/FormInput";
import moment from "moment";
import FormSelect from "../../components/FormSelect";
import { getTransporters } from "../../services/transporters.service";
import { formatIndianAmount, formatIndianInteger } from "../../utils/numberFormat";
// import { exportExcelParty } from "../../services/parties.service";

const initialState = {
  data: [],
  page: 1,
  limit: 100,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 100,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    default:
      return state;
  }
}

const columns = [
  {
    selector: (row: DispatchData) => row.serialNumber,
    name: "S.No.",
    sortable: false,
    //   wrap: true,
    maxWidth: "70px",
    minWidth: "70px",
  },

  {
    selector: (row: DispatchData) => moment(row.dispatchDate).format("DD-MM-YYYY"),
    name: "Dispatch Date",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: any) => row.transporterName || "N/A",
    name: "Transporter Name",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: DispatchData) => row.driverName,
    name: "Driver Name",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: DispatchData) => row.vehicleNumber,
    name: "Vehicle Number",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: DispatchData) => formatIndianInteger(row.totalParty),
    name: "Total Party",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: DispatchData) => formatIndianInteger(row.totalPicklist),
    name: "Total Picklist",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: DispatchData) => formatIndianInteger(row.totalInvoice),
    name: "Total Invoice",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: DispatchData) => formatIndianAmount(row.invoiceAmount),
    name: "Invoice Amount",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: DispatchData) => row.grNumber,
    name: "Route",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => (
      <>
        <Link className='me-1' to={`print/${row.id}`} target='_blank'>
          <Printer size={15} />
        </Link>
      </>
    ),
    name: "Actions",
    sortable: false,
    center: true,
    maxWidth: "90px",
    minWidth: "90px",
  },
];

function DispatchReports() {
  const [filterData, setFilterData] = useState({
    transporter: "",
    driverName: "",
    vehicleNumber: "",
    dispatchFrom: "",
    dispatchTo: "",
  });
  const [transporter, setTransporter] = useState("");
  const [loading, setLoading] = useState(true);
  const [data, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const navigate = useNavigate();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };

  const parseDateValue = (value: unknown) => {
    if (typeof value !== "string" || !value) {
      return null;
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  useEffect(() => {
    const { page, transporter, driverName, vehicleNumber, dispatchFrom, dispatchTo } = query;
    setFilterData({
      transporter: typeof transporter === "string" ? transporter : "",
      driverName: typeof driverName === "string" ? driverName : "",
      vehicleNumber: typeof vehicleNumber === "string" ? vehicleNumber : "",
      dispatchFrom: typeof dispatchFrom === "string" ? dispatchFrom : "",
      dispatchTo: typeof dispatchTo === "string" ? dispatchTo : "",
    });

    setLoading(true);

    getDispatches({ page, transporter, driverName, vehicleNumber, dispatchFrom, dispatchTo })
      .then((response: any) => {
        setData(response.data);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, [location.search]);

  const handleFilter = () => {
    const queryParams: any = { ...query, page: 1, ...filterData };

    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });

    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}${Object.keys(queryParams).length > 0 ? "?" + queryString : ""}`);
  };
  const handleClearFilter = () => {
    setFilterData({
      transporter: "",
      driverName: "",
      vehicleNumber: "",
      dispatchFrom: "",
      dispatchTo: "",
    });
    setTransporter("");
    const queryParams = { page: 1 };
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}?${queryString}`);
  };

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2 page-title-row'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Dispatch Report</h1>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-hidden' style={{ height: "calc(100vh - 230px)" }}>
        <Card className='h-100 p-3 w-100 '>
          <div className='d-flex flex-column h-100 rounded-0 list-data-grid-wrapper'>
            <DataGrid
              columns={columns}
              data={data}
              loading={loading}
              isFilterApplied={Object.keys(query).some((key) => key !== "page")}
              noDataTitle='No dispatch reports found'
              noDataSubtitle='There are no dispatch reports available right now.'
              noDataFilteredTitle='No dispatch reports match your filters'
              noDataFilteredSubtitle='Try changing or clearing the filter criteria.'
              filterByDate={true}
              FilterSubHeader={true}
              filterData={filterData}
              setFilterData={setFilterData}
              subHeaderComponent={
                <Row className='w-100 align-items-start g-3 py-1 px-1'>
                  <Col md={2}>
                    <FormSelect
                      id='transporter'
                      name='transporter'
                      label='Transporter'
                      isAsync
                      isClearable
                      defaultFilter={{ status: true }}
                      getOptions={getTransporters}
                      onChange={(name: any, value: any) => {
                        setTransporter(value);
                        setFilterData({
                          ...filterData,
                          [name]: value?.id,
                        });
                      }}
                      value={transporter}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='driverName'
                      label='Driver Name'
                      placeholder='Driver Name'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.driverName}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='vehicleNumber'
                      label='Vehicle Number'
                      placeholder='Vehicle Number'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.vehicleNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <div
                      className='form-label'
                      style={{ fontSize: "0.875rem", fontWeight: 500, marginBottom: "0.375rem" }}
                    >
                      Date Range
                    </div>
                    <DatePicker
                      selectsRange
                      startDate={parseDateValue(filterData.dispatchFrom)}
                      endDate={parseDateValue(filterData.dispatchTo)}
                      onChange={(dates: [Date | null, Date | null]) => {
                        const [startDate, endDate] = dates;
                        setFilterData({
                          ...filterData,
                          dispatchFrom: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
                          dispatchTo: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
                        });
                      }}
                      isClearable
                      dateFormat='dd/MM/yyyy'
                      className='form-control'
                      placeholderText='Select date range'
                    />
                  </Col>
                  <Col md='auto'>
                    <div className='filter-action-buttons'>
                      <Button color='primary' size='sm' onClick={() => handleFilter()}>
                        Filter
                      </Button>
                      <Button color='danger' size='sm' onClick={() => handleClearFilter()}>
                        Clear
                      </Button>
                    </div>
                  </Col>
                </Row>
              }
            />
          </div>
        </Card>
      </div>
    </div>
  );
}

export default DispatchReports;
